import { isNil, sortBy } from 'lodash'

export const IFG_PARENT_ORG_IDS = [1092, 727]

const pad2 = (value) => String(value).padStart(2, '0')

export const formatHMS = (ms) => {
  if (isNil(ms) || Number.isNaN(ms)) {
    return '—'
  }
  const totalSeconds = Math.floor(ms / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  return `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`
}

export const formatShortDate = (iso) => {
  if (!iso) {
    return '—'
  }
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export const formatDateStamp = (iso) => {
  if (!iso) {
    return { date: '—', time: '' }
  }
  const parsed = new Date(iso)
  return {
    date: parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
    time: parsed.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }),
  }
}

// A course is visible when it's active, has a "Category: Title" colon prefix,
// and—if it's an IFG category—the org's parent is an IFG org. Shared by the
// Courses page (grouped display) and the Reporting page (course filter) so the
// two always show the same set.
export const getVisibleCourses = (courses = [], parentOrgId) =>
  courses.filter((course) => {
    if (!course.active || !course.title) {
      return false
    }
    const colonIndex = course.title.indexOf(':')
    if (colonIndex === -1) {
      return false
    }
    const category = course.title.slice(0, colonIndex).trim()
    if (category.includes('IFG') && !IFG_PARENT_ORG_IDS.includes(parentOrgId)) {
      return false
    }
    return true
  })

export const categorizeCourses = (courses, parentOrgId) => {
  const grouped = {}

  getVisibleCourses(courses, parentOrgId).forEach((course) => {
    const colonIndex = course.title.indexOf(':')
    const category = course.title.slice(0, colonIndex).trim()
    const displayTitle = course.title.slice(colonIndex + 1).trim()
    if (!grouped[category]) {
      grouped[category] = []
    }
    grouped[category].push({ ...course, displayTitle })
  })

  Object.keys(grouped).forEach((category) => {
    grouped[category] = sortBy(grouped[category], 'created').reverse()
  })

  return grouped
}
